import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { BrowserRouter } from 'react-router-dom'
import { Integrations } from '@sentry/tracing'

import App from './App'
import reportWebVitals from './reportWebVitals'

import { currentBrand } from './config'
import 'react-phone-number-input/style.css'
import './theme/app/app.less'

Sentry.init({
	dsn: 'https://9331697a816e4462b418d185bac751c2@o679923.ingest.sentry.io/5771646',
	integrations: [new Integrations.BrowserTracing()],
	tracesSampleRate: 1.0,
	environment: process.env.NODE_ENV,
})

setStyleVar(currentBrand.styles)

ReactDOM.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
	document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

/* eslint-disable @typescript-eslint/no-explicit-any */

function setStyleVar(value: any) {
	const win: any = window
	if (win.less?.modifyVars) win.less?.modifyVars(value)
}
